import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FaTools, FaShieldAlt, FaClock, FaHeadset, FaCogs } from 'react-icons/fa';
import '../styles/DesktopSupport.css';  // Custom styles

const DesktopSupport = () => {
 useEffect(() => {
    window.scrollTo(0, 0); // Force scroll to top

  AOS.init({ duration: 800, once: true });
}, []);


  return (
    <div className="desktop-support py-5">
      {/* Hero Section */}
      <Container className="mb-5" data-aos="fade-down">
        <Row className="align-items-center">
          <Col md={6} className="mb-4 mb-md-0">
            <h1 className="fw-bold hero-title">
             Desktop Support Services
            </h1>
            <p className="text-muted hero-tagline">
Desktop Support Services ensure that end users receive timely and effective technical assistance for their workplace devices and software. From troubleshooting system errors to configuring applications, this service provides frontline IT support that keeps businesses running smoothly.            </p>
          </Col>
         <Col md={6} data-aos="fade-left">
                     <video
                       src="/videos/DesktopSupport.mp4"
                       className="img-fluid rounded shadow network-video mt-5"
                       autoPlay
                       loop
                       muted
                       playsInline
                     />
                   </Col>
        </Row>
 
      </Container>

      {/* Reliable Desktop Support Section */}
     <Container className="mb-5" data-aos="fade-up">
  <h3 className="fw-bold text-center mb-3">Reliable Desktop Support</h3>
  <p className="text-muted text-center mb-4 mx-auto info-text">
    Our desktop support services ensure your business operations run smoothly by providing prompt and efficient support for your desktop systems. We offer a range of services to address any issues and keep your workstations performing optimally.
  </p>
  <Row className="justify-content-center">
    <Col md={8}>
      <ul className="list-unstyled support-list">
        <li data-aos="fade-right"> Installation and configuration of desktop systems</li>
        <li data-aos="fade-right" data-aos-delay="100"> Troubleshooting and repair</li>
        <li data-aos="fade-right" data-aos-delay="200"> Software installation and updates</li>
        <li data-aos="fade-right" data-aos-delay="300"> Hardware upgrades and replacements</li>
        <li data-aos="fade-right" data-aos-delay="400"> Remote and on-site support</li>
      </ul>
    </Col>
  </Row>
                    {/* <div className="divider my-5"></div> */}

</Container>


      {/* Features Section */}
      <Container className="mb-5">
        <Row className="g-4">
          <Col md={4} data-aos="fade-up">
            <Card className="p-4 text-center h-100 shadow-sm glass-card">
              <FaTools size={40} className="text-primary mb-3" />
              <h5>Troubleshooting & Repair</h5>
              <p className="text-muted">Hardware and software issue resolution by experts.</p>
            </Card>
          </Col>
          <Col md={4} data-aos="fade-up" data-aos-delay="100">
            <Card className="p-4 text-center h-100 shadow-sm glass-card">
              <FaCogs size={40} className="text-success mb-3" />
              <h5>System Optimization</h5>
              <p className="text-muted">Upgrade and optimize system performance for efficiency.</p>
            </Card>
          </Col>
          <Col md={4} data-aos="fade-up" data-aos-delay="200">
            <Card className="p-4 text-center h-100 shadow-sm glass-card">
              <FaShieldAlt size={40} className="text-danger mb-3" />
              <h5>Security & Virus Removal</h5>
              <p className="text-muted">Keep your systems safe and protected from threats.</p>
            </Card>
          </Col>
        </Row>
                          {/* <div className="divider my-5"></div> */}

      </Container>

      {/* Our Process Section */}
      <Container className="mb-5">
        <h3 className="text-center fw-bold mb-4" data-aos="fade-up">How It Works</h3>
        <Row className="text-center g-4">
          <Col md={4} data-aos="zoom-in">
            <Card className="p-3 shadow-sm h-100 glass-card">
              <FaHeadset size={35} className="text-info mb-2" />
              <h6>Step 1: Raise a Ticket</h6>
              <p className="text-muted">Let us know your issue via email or the portal.</p>
            </Card>
          </Col>
          <Col md={4} data-aos="zoom-in" data-aos-delay="100">
            <Card className="p-3 shadow-sm h-100 glass-card">
              <FaClock size={35} className="text-warning mb-2" />
              <h6>Step 2: Quick Response</h6>
              <p className="text-muted">Our expert gets in touch to assist you quickly.</p>
            </Card>
          </Col>
          <Col md={4} data-aos="zoom-in" data-aos-delay="200">
            <Card className="p-3 shadow-sm h-100 glass-card">
              <FaTools size={35} className="text-primary mb-2" />
              <h6>Step 3: Issue Resolved</h6>
              <p className="text-muted">Problem fixed on-site or via remote assistance.</p>
            </Card>
          </Col>
        </Row>
                          {/* <div className="divider my-5"></div> */}

      </Container>

      {/* Why Choose Us Section */}
      <Container className="mb-5">
        <h3 className="text-center fw-bold mb-4" data-aos="fade-right">Why Choose Our Support?</h3>
        <Row className="g-4">
          <Col md={6} lg={3} data-aos="fade-right">
            <Card className="text-center p-4 shadow-sm glass-card">
              <h6>Experienced Technicians</h6>
              <p className="text-muted">Skilled team with years of desktop troubleshooting experience.</p>
            </Card>
          </Col>
          <Col md={6} lg={3} data-aos="fade-right" data-aos-delay="100">
            <Card className="text-center p-4 shadow-sm glass-card">
              <h6>Fast Turnaround</h6>
              <p className="text-muted">We value your time with quick and accurate solutions.</p>
            </Card>
          </Col>
          <Col md={6} lg={3} data-aos="fade-right" data-aos-delay="200">
            <Card className="text-center p-4 shadow-sm glass-card">
              <h6>Cost-Effective</h6>
              <p className="text-muted">Affordable pricing for top-tier support.</p>
            </Card>
          </Col>
          <Col md={6} lg={3} data-aos="fade-right" data-aos-delay="300">
            <Card className="text-center p-4 shadow-sm glass-card">
              <h6>24/7 Availability</h6>
              <p className="text-muted">Anytime assistance via phone, chat or email.</p>
            </Card>
          </Col>
        </Row>
                          {/* <div className="divider my-5"></div> */}

      </Container>

      {/* Call to Action */}
      <Container className="text-center mt-5" data-aos="zoom-in">
        <h4 className="fw-bold mb-3">Ready to Get Started?</h4>
        <p className="text-muted mb-4">Reach out to our team today for dedicated desktop support.</p>
        <Button
          variant="primary"
          href="/contact"
          className="cta-button shadow"
        >
          Contact Us
        </Button>
      </Container>
    </div>
  );
};

export default DesktopSupport;
